import { put, call, takeLatest } from 'redux-saga/effects'

import { getDocsWorkflowStepReview } from 'Service/Api'

import * as workFlowStepTypes from 'Redux/Types/WorkFlowStepTypes'
import * as workFlowStepActions from 'Redux/Actions/WorkFlowStepActions'

function* getWorkFlowStepReviewEmail({ payload }) {
  try {
    const response = yield call(getDocsWorkflowStepReview, payload)
    yield put(workFlowStepActions.getWorkFlowStepReviewEmailSucceeded(response))
  } catch (errors) {
    yield put(workFlowStepActions.getWorkFlowStepReviewEmailFailed(errors))
  }
}

export default function* WorkFlowStatusSaga() {
  yield takeLatest(workFlowStepTypes.GET_WORKFLOW_STEP_EMAIL, getWorkFlowStepReviewEmail)
}
